import { buildClass, checkClass } from "@utils/tag";
import CustomImage from "@components/CustomImage";

export const IconUnChecked = ({ isMulti = false, sx }) => {
  return (
    <div
      style={{
        background: "#FFFFFF",
        boxShadow: "1px -1px 2px 0px #00000014",
        ...sx,
      }}
      className={buildClass(
        "flex items-center justify-center",
        "max-w-[18px] max-h-[18px]",
        "flex w-[18px] h-[18px] min-w-[18px] min-h-[18px]",
        checkClass(isMulti, ["rounded-sm", "rounded-full"])
      )}
    >
      <div
        style={{
          border: "1px solid #0366FF",
          boxShadow: "1px -1px 2px 0px #00000014",
        }}
        className={buildClass(
          checkClass(isMulti, ["rounded-sm", "rounded-full"]),
          "max-w-[14px] max-h-[14px] flex w-[14px]",
          "h-[14px] min-w-[14px] min-h-[14px]"
        )}
      />
    </div>
  );
};

export const IconChecked = ({ isMulti = false, sx }) => {
  return (
    <div
      style={{
        background: "#ffffff",
        boxShadow: "1px -1px 2px 0px #00000014",
        ...sx,
      }}
      className={buildClass(
        "flex items-center justify-center",
        "max-w-[18px] max-h-[18px]",
        "flex w-[18px] h-[18px] min-w-[18px] min-h-[18px]",
        checkClass(isMulti, ["rounded-sm", "rounded-full"])
      )}
    >
      <CustomImage
        className={buildClass(
          "max-w-[14px] max-h-[14px] flex w-[14px]",
          " h-[14px] min-w-[14px] min-h-[14px]",
          checkClass(isMulti, ["rounded-sm", "rounded-full"])
        )}
        src="/images/global/check.png"
        width={15}
        height={15}
        alt="checked"
      />
    </div>
  );
};
